export const findUserById = (userId, users) =>
	users.find((user) => user._id === userId);
